import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsGear1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSettingsGear1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 17.085V6.91495L12 1.85254L21 6.91498L21 17.0847L12 22.1471L3 17.085ZM8.50003 12C8.50003 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.50003 13.933 8.50003 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsGear1;
